import { DatePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { catchError, EMPTY, map, switchMap, tap } from 'rxjs'

import { CmsService } from 'app/core/cms/cms.service'
import { CmpLatestNews, PublicationCardItem } from 'app/core/cms/generated/api-types'
import { ApplyPipe } from 'app/shared/apply/apply.pipe'
import { CmsLinkDirective } from 'app/shared/cms-link/cms-link.directive'
import { RippleDirective } from 'app/shared/ripple/ripple.directive'
import { IconComponent } from 'app/shared/svg/icon.component'
import { createCmsLinkFromCardItem } from 'app/utils/create-cms-link-from-card-item.function'

import { CmsBlock } from '../../cms-block'

@Component({
  selector: 'pai-cmp-latest-news',
  templateUrl: './cmp-latest-news.component.html',
  styleUrls: ['./cmp-latest-news.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, RippleDirective, IconComponent, CmsLinkDirective, ApplyPipe],
  providers: [{ provide: CmsBlock, useExisting: CmpLatestNewsComponent }],
})
export class CmpLatestNewsComponent extends CmsBlock<CmpLatestNews> {
  readonly __typename = 'CmpLatestNews'

  protected readonly items = {
    value: signal<readonly PublicationCardItem[] | undefined>(void 0),
    error: signal<null | Error>(null),
  } as const

  protected readonly machMauLinkDrus = createCmsLinkFromCardItem

  private readonly cmsService = inject(CmsService)

  constructor() {
    super()

    toObservable(this.data)
      .pipe(
        switchMap(({ categories, count }: CmpLatestNews) =>
          this.cmsService.getPublicationCards(categories?.map((c) => c.id) ?? [], 0, count ?? 3),
        ),
        map((result) => result.cards),
        catchError((error: unknown) => {
          this.items.value.set(void 0)
          this.items.error.set(error instanceof Error ? error : new Error('unknown error', { cause: error }))
          return EMPTY
        }),
        tap((items) => {
          this.items.value.set(items)
          this.items.error.set(null)
        }),
      )
      .subscribe()
  }
}
